var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { DnD, InfoTooltip } from '../index';
import { useState } from 'react';
import { Modal } from '../index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faDiagramProject, faTrash } from '@fortawesome/free-solid-svg-icons';
import { initialiseFieldMeta } from './Field';
import { Row, Button, Col } from 'react-bootstrap';
import { deleteFieldMetaFromStorage } from './Utils';
function ConfigModal(props) {
    var tableId = props.tableId, fieldMeta = props.fieldMeta, open = props.open, setOpen = props.setOpen, modalOnSave = props.modalOnSave, pageSize = props.pageSize;
    var _a = useState({}), contents = _a[0], setContents = _a[1];
    var updateMeta = function (list, updatedFieldMeta, hidden) {
        for (var _i = 0, _a = Object.values(list); _i < _a.length; _i++) {
            var element = _a[_i];
            var id = element['id'];
            var isActive = hidden ? 'inactive' : 'active';
            updatedFieldMeta.order[isActive].push(id);
            // make a copy and update visibility
            updatedFieldMeta.data[id] = fieldMeta.data[id];
            updatedFieldMeta.data[id].hidden = hidden;
        }
    };
    var fieldMetaUpdatedByContents = function (pageSize) {
        var updatedFieldMeta = initialiseFieldMeta(pageSize);
        // loop through columns and set active/inactive
        for (var _i = 0, _a = Object.values(contents); _i < _a.length; _i++) {
            var column = _a[_i];
            var id = column['id'];
            var list = column['list'];
            if (id === 'Active') {
                updateMeta(list, updatedFieldMeta, false);
            }
            else if (id === 'Inactive') {
                updateMeta(list, updatedFieldMeta, true);
            }
        }
        // sort order of inactive alphabetically
        updatedFieldMeta.order.inactive = updatedFieldMeta.order.inactive.sort();
        return updatedFieldMeta;
    };
    var uiElement = function (key, meta) {
        return (_jsxs("div", __assign({ className: 'tol-dnd-item' }, { children: [meta['description'] &&
                    _jsx("span", __assign({ className: 'info' }, { children: _jsx(InfoTooltip, { contents: meta['description'] }) })), meta['rename'], !meta['isAttribute'] && _jsx(FontAwesomeIcon, { className: 'icon', icon: faDiagramProject, size: "xs" }), _jsx("div", __assign({ className: 'field-name-origin' }, { children: key }))] })));
    };
    var fieldMetaItemToElement = function (isActive) {
        var items = [];
        for (var _i = 0, _a = fieldMeta.order[isActive]; _i < _a.length; _i++) {
            var key = _a[_i];
            items.push({
                id: key,
                element: uiElement(key, fieldMeta.data[key])
            });
        }
        return items;
    };
    var fieldMetaToElements = function () {
        var elements = {};
        elements['Active'] = fieldMetaItemToElement('active');
        elements['Inactive'] = fieldMetaItemToElement('inactive');
        return elements;
    };
    var dealWithContents = function (column) {
        if (column['id'] === "Active") {
            if (column['list'].length === 0) {
                return false;
            }
        }
        return true;
    };
    var saveConfig = function () {
        var updatedFieldMeta = fieldMetaUpdatedByContents(pageSize);
        modalOnSave(updatedFieldMeta);
        setOpen(false);
    };
    var saveButton = (_jsx(Button, __assign({ variant: "success", onClick: saveConfig }, { children: _jsx(FontAwesomeIcon, { icon: faFloppyDisk, size: "sm" }) })));
    var header = (_jsxs(_Fragment, { children: [_jsxs(Row, __assign({ style: { marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: 0 } }, { children: [_jsx(Col, __assign({ sm: 6, style: { paddingLeft: 0, paddingRight: 0 } }, { children: _jsx("h2", { children: "Table Settings" }) })), _jsx(Col, __assign({ sm: 6, style: { paddingLeft: 0, paddingRight: 0 } }, { children: _jsxs(Button, __assign({ className: "clear-saved-config", style: { float: "right" }, variant: "warning", onClick: function () {
                                deleteFieldMetaFromStorage(tableId);
                            } }, { children: ["Clear Saved Configuration", _jsx(FontAwesomeIcon, { icon: faTrash, size: "sm" })] })) }))] })), _jsx("hr", {})] }));
    return (_jsx(Modal, __assign({ open: open, size: 'full', setOpen: setOpen, header: header, actionButton: saveButton }, { children: _jsx(DnD, { elements: fieldMetaToElements(), setContents: setContents, dealWithContents: dealWithContents }) })));
}
export default ConfigModal;
